import ItemAgenda from "../../components/ItemAgenda/ItemAgenda";
import Titles from "../../components/Titles/Titles";
const Agenda = ({ events }) => {
	return (
		<div className="container containerPadding100">
			<Titles title={"AGENDA"} color={"white"} margin="0 0 60px 0" />
			{events && events.length > 0 ? (
				events.map((event, index) => {
					return <ItemAgenda key={index} event={event} />;
				})
			) : (
				<p style={{ color: "white", textAlign: "center", fontSize: "18px", marginTop: "40px" }}>
					Aucun événement prévu pour le moment. Revenez bientôt !
				</p>
			)}
		</div>
	);
};


export default Agenda;
